import React from 'react'
import { compose } from 'recompose'
import { routesByValue } from 'helpers/routesConstant'
import withViewAllPage from 'hocs/extends/withViewAllPage'
import withDuplicateResource from 'hocs/extends/withDuplicateResource'
import AwesomeTable from 'components/Table/AwesomeTable'
import PageView from 'material-ui/svg-icons/action/pageview'
import ContentCopy from 'material-ui/svg-icons/content/content-copy'
import MoreAction from 'components/MoreAction'
import withPreview from 'store/preview/withPreview'

const ViewAllPages = compose(
  withViewAllPage({
    resourceName: {
      singular: 'page',
      plural: 'pages',
    },
  }),
  withDuplicateResource({
    resourceName: {
      singular: 'page',
      plural: 'pages',
    },
  }),
  withPreview(),
)(
  ({
    pages,
    router,
    onOpenTempState,
    deletePage,
    deletePageStatus,
    setOpenModal,
    setOriginalResourceInfo,
    setNewResourceName,
    duplicateStatus,
    renderAddResourceButton,
    // preview
    openPagePreviewer,
  }) => {
    const config = [
      {
        headerLabel: 'Name',
        accessor: 'name',
        sortable: true,
        width: '65%',
      },
      {
        headerLabel: 'Last Updated',
        accessor: 'lastUpdated',
        isDate: true,
        sortable: true,
        width: '20%',
      },
      {
        width: '15%',
        renderCell: ({ rowData }) => (
          <MoreAction.Default
            grey
            onEdit={() => router.push(routesByValue.editPage.getRoute(rowData.id))}
            onDelete={() => onOpenTempState({
              action: () => deletePage(rowData.id),
              content: `Delete ${rowData.name} ?.`,
            })}
            menus={{
              pageView: {
                name: 'Preview',
                icon: <PageView />,
                onClick: () => openPagePreviewer(rowData.id),
              },
              duplicate: {
                name: 'Duplicate',
                icon: <ContentCopy />,
                onClick: () => {
                  setOpenModal(true)
                  setOriginalResourceInfo(rowData)
                  setNewResourceName(`${rowData.name} (copy)`)
                },
              },
            }}
          />
        ),
        cellProps: {
          className: 'more-actions',
        },
      },
    ]
    return (
      <AwesomeTable
        defaultSortKey={'name'}
        defaultSortType={'asc'}
        rawData={pages}
        config={config}
        loading={duplicateStatus.isRequest || deletePageStatus.isRequest}
      >
        {renderAddResourceButton()}
      </AwesomeTable>
    )
  },
)

ViewAllPages.propTypes = {}
ViewAllPages.defaultProps = {}

export default ViewAllPages



// WEBPACK FOOTER //
// ./src/pages/CustomPages/children/ViewAllPages.js